import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const NumberOfSites = () => (
    <div>
        <h2>
            <FormattedMessage
                id="JiraSoftwarePricingPage.content-modal.number-of-sites.heading"
                defaultMessage="Number of sites"
            />
        </h2>
        <p>
            <FormattedMessage
                id="JiraSoftwarePricingPage.content-modal.number-of-sites.p1"
                defaultMessage="This is the number of sites (also called “instances”) you can license based on the subscription plan you choose. One site is typically enough for most small to medium organizations."
            />
        </p>
        <p>
            <FormattedMessage
                id="JiraSoftwarePricingPage.content-modal.number-of-sites.p2"
                defaultMessage="Enterprise subscribers often opt for multiple sites, up to 150 per product, to:"
                description="Enterprise is a product plan and should not be translated. Following this is a list of things Enterprise subscribers can do"
            />
        </p>
        <ul>
            <FormattedMessage
                id="JiraSoftwarePricingPage.content-modal.number-of-sites.list-items"
                defaultMessage="<li>Offer organizational autonomy to independent brands</li> <li>Improve security through separating data by region or department</li> <li>Customize instances based on Marketplace apps, project configurations, and more</li>"
                values={{ ...DEFAULT_VALUES, li: (chunk) => <li>{chunk}</li> }}
            />
        </ul>
        <div>
            <FormattedMessage
                id="JiraSoftwarePricingPage.content-modal.number-of-sites.learn-more"
                defaultMessage="<a>Learn more</a> about instances in Jira."
                values={{
                    ...DEFAULT_VALUES,
                    a: (chunk) => (
                        <a
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            href={`https://support.atlassian.com${useLocalizedHref(
                                "/organization-administration/docs/how-many-instances-of-a-product-does-my-organization-need/"
                            )}`}
                            data-event="clicked"
                            data-event-component="linkButton"
                            data-product-key="jiraSoftware"
                        >
                            {chunk}
                        </a>
                    )
                }}
            />
        </div>
    </div>
);

export default NumberOfSites;
